"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = function (key) {
    var cookieString = "; " + document.cookie;
    var match = cookieString.match(new RegExp("; " + key + "=([^;]+)"));
    return match ? match[1] : null;
};
exports.set = function (key, value) {
    document.cookie = key + "=" + value;
};
exports.reset = function (key) {
    document.cookie = key + "=";
};
